<div class="smart-tags-container">
    <div class="container header">
        <div class="row">
            <div class="col-sm-6 title">
                <label>
                    Smart Tags
                    <ng-container *ngIf="totalSmartTags > 0">
                        ({{ totalSmartTags }})
                    </ng-container>
                </label>
            </div>
            <div class="col-sm-6 add-btn" *ngIf="!options.externalProcess && data">
               <ng-container *ngIf="totalSmartTags > 0">
                    <cv-dropdown-button
                        class="smart-tag-list-dropdown"
                        [label]="selectedSmartTagType || 'Navigate to'"
                        [isImg]="false"
                        [position]="'down'"
                        [buttonClass]="'btn-sm cv-btn-light'"
                        [items]="navigateItems"
                        (subOptionClick)="scrollToSmartTagGroup($event)">
                    </cv-dropdown-button>
                </ng-container>
            </div>
            <div class="col-sm-6 add-btn"
                *ngIf="options.externalProcess && data && isEditable">
                <button (click)="onCreate()"
                    type="button"
                    class="btn btn-primary">
                    Add Smart Tag
                </button>
            </div>
        </div>
    </div>

    <div *ngIf="data"
        id="list-container-{{this.data.roomId}}"
        class="smart-tags-list container"
        [scrollTop]="scrollPosition">

        <div *ngFor="let smartTagGroup of smartTagsGroups;">
            <div class="row smart-tag-type sticky-top">
                <div class="col-md-12">
                    <label class="smart-tag-group-name">{{smartTagGroup.name}}</label>
                    <label class="smart-tag-group-counter">({{smartTagGroup.items.length}})</label>
                </div>
            </div>
            <div class="row smart-tag-content" id="{{smartTagGroup.id}}">
                <cv-schema-render-smart-tag-item *ngFor="let item of smartTagGroup.items"
                    [item]="item"
                    [path]="path"
                    [external]="options.externalProcess"
                    [version]="options.version"
                    (edit)="onEdit($event)">
                </cv-schema-render-smart-tag-item>
            </div>
        </div>

        <div class="empty-rules-message" *ngIf="smartTagsGroups.length === 0 ">
            <div>
                <img src="assets/img/placeholder/No-file-asset.png">
                <label class="no-results">No Smart Tags Available</label>
            </div>
        </div>
    </div>
</div>
